import { connect } from 'react-redux';
import { enterSpace } from '../../app/actions/spaces/EnterSpaceAction';
import { addContentFavorite, removeContentFavorite } from '../../app/actions/spaces/FavoritesActions';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';
import { DataRoleSpace, DataRoleSpaceDispatchProps, DataRoleSpaceOwnProps, DataRoleSpaceStateProps } from './DataRoleSpace';

const mapStateToProps: MapStateToProps<DataRoleSpaceStateProps> = (state) => ({
  urls: siteUrlsSelector(state),
});

const mapDispatchToProps: MapDispatchToProps<DataRoleSpaceDispatchProps, DataRoleSpaceOwnProps> = (dispatch, ownProps) => ({
  enterSpace: () => {
    dispatch(enterSpace({
        item: {
            contentType: 'dataRole',
            id: ownProps.dataRoleDetailInfoWithUsage.id,
        },
        spaceType: 'dataRole',
        subspaceName: 'definition',
    }));
  },
  addToFavorites: () => {
    dispatch(addContentFavorite(ownProps.dataRoleDetailInfoWithUsage.id, 'dataRole'));
  },
  removeFromFavorites: () => {
    dispatch(removeContentFavorite(
      ownProps.dataRoleDetailInfoWithUsage.id,
      ownProps.dataRoleDetailInfoWithUsage.id,
      'dataRole',
      ownProps.dataRoleDetailInfoWithUsage.name));
  },
});

export const ConnectedDataRoleSpace = connect(mapStateToProps, mapDispatchToProps)(DataRoleSpace);
